<template>
<div>
  <Breadcrumb :title="'Distribution Report'"></Breadcrumb>
  <div class="input-group">
        <div class="form-group col-md-12">
            <label class="section-title">Select Report Criteria</label>
        </div>
        <br>
        <div class="input-group">
            <div class="form-group col-md-12">
                <div class="multi-field multi-field-left col-md-4">
                    <label style="display:block">Program</label>
                     <div id="kendo-select">
                      <!-- <kendo-dropdownlist v-model="criteriaData.Program"
                                :data-source="dropdowns.Program"
                                :data-text-field="'Option'"
                                :option-label="'Select Program'"
                                :data-value-field="'Id'">
                      </kendo-dropdownlist> -->
                      <!-- <div id="kendo-select"> -->
                        <kendo-autocomplete
                          id="SearchFmvProgram"
                          class="form-control"
                          :data-source="dropdowns.Program"
                          :data-text-field="'Option'"
                          :data-value-field="'Id'"
                          :filter="'contains'"
                          :placeholder="'Search for Program'"
                          @select="onProgramChange"
                        ></kendo-autocomplete>
                      <!-- </div>                       -->
                    </div>
                    <!-- <select v-model="criteriaData.Program" class="form-control">
                      <option
                        v-for="option in dropdowns.Program"
                        :key="option.Id"
                        :value="option.Id"
                      >{{option.Option}}</option>
                    </select> -->
                </div>
                <div class="multi-field col-md-8">
                  <kendo-daterangepicker id="rangePicker"
                           :range="currentRange"
                           :format="'MM/dd/yyyy'"
                           v-on:change="onChange">
                  </kendo-daterangepicker>
                </div>
            </div>
        </div>
        <br>
        <div class="row" style="width: 100%">
            <div class="col text-center">
                <button class="btn btn-primary" 
                 :disabled="criteriaData.StartDate == '' || criteriaData.EndDate == ''"
                 style="margin:auto" @click="getReportData"><span class="fa fa-list"></span> &nbsp;Run Report</button>
            </div>
        </div>
    </div>
    <br>
        
  <div class='btnDiv'>
    <BaseToolBar v-if="displayGrid"  @buttonClicked="toolbarOnClick"></BaseToolBar>
  </div>
  <div>
    <BaseGrid v-if="displayGrid" :config="currentGridConfig" :excelExport="excelExport" :mode="'editform'" :data="DistributionReportData"  ></BaseGrid>
  </div>
</div>
</template>

<script>
import $ from 'jquery';
import { GridConfig}  from "./DistributionReportConfig.js";
import BaseModelDistribution from "@/models/BaseModelDistribution.js";
import Breadcrumb from "@/components/layout/Breadcrumb.vue";
import BaseGrid from "@/components/base/BaseGrid.vue";
import apiUtil from "@/services/apiUtil.js";
import funcUtil from "@/services/funcUtil.js";
import BaseSearchBar from "@/components/base/BaseSearchBar.vue";
import BaseToolBar from "@/components/base/BaseToolbar.vue";
import toolbarUtility from "@/services/toolbarUtility.js";
import DistributionForm from "@/components/forms/DistributionForm.vue";
import BaseModelUnitClass from "@/models/BaseModelUnitClass.js";
import BaseModelProgram from "@/models/BaseModelProgram.js";
import {mapGetters, mapActions, mapState } from 'vuex';
import moment from "moment";
// import deepGroupBy from "@/services/groupByUtil.js";

export default {
  name: "DistributionReport",
  mixins: [apiUtil, funcUtil, toolbarUtility],
  components: {
    Breadcrumb,
    BaseGrid,
    BaseToolBar,
  },
   computed: {
    ...mapGetters("getModule",["withFilter","getLocalInputControls"]),
    ...mapState("postModule",["response"]),
     
  },
  data: function () {
    return {
      currentRange: {start: null, end: null},
      GridConfig: GridConfig,
      currentGridConfig:{},
      grid: $("#" + GridConfig.grid.gridId).data("kendoGrid"),
      search: {
        SearchData: "",
      },
      DistributionReportGridId: "DistributionReportGrid",
      DistributionMasterData: {},
    //   ToolbarConfig: ToolbarConfig,
      BaseModelDistribution: BaseModelDistribution,      
      BaseModelUnitClass: BaseModelUnitClass,
      BaseModelProgram: BaseModelProgram,
      modalConfig: {
        modalName: "",
        modalAddorEdit: ""
      },
      DistributionJSON:  {       
      },
      // DistributionAddJSON: {
      //Id: "",
      // BusinessEvent:"",
      // ProgramId:"",
      // ReceiverId:"",
      // ProgramTitle:"",
      // ReceiverFullName:"",
      // UnitClass:"",
      // UnitType:"",
      // UnitPool:"",
      // Unit:"",
      // TransactionDate:"",                        
      // },
      DistributionEditJSON: {
        Id: "",
        PartnerId:"",
        PartnerPartnerID:"",
        PartnerFullName:"",
        ProgramId:"",
        ProgramProgramID:"",
        ProgramTitle:"",
        DistributionType1:"",
        DistributionType2:"",
        DistributionPartnerType:"",
        DistributionDate:"",  
        DistributionAmount:"",
        Note:""
      },
      DistributionData:[],
      DistributionValuationData:[],
      DistributionInfoData:[],    
      dropdowns: {
        Program: { model: "", dataSource: [] },        
      },
      displayGrid:false,
      criteriaData: {
            Program: "", 
            StartDate: "", 
            EndDate: "" 
      },
      DistributionReportData:[],
     

    }
  },
  mounted() {
    const self = this;
    console.log(self.grid)
    self.currentGridConfig = JSON.parse(JSON.stringify(self.GridConfig));
    //changes for Toolbar    
    // self._loadGridSettings(self.DistributionReportGridId);
    self.getInputControls();
    
        
//     //bind databound event to grid
//     const grid = $("#DistributionReportGrid").data("kendoGrid");
//     grid.bind("dataBound", self.UpdateDistributionMasterData);
//     // grid.dataSource.fetch();

// //get the data from Distribution  table. Combine to form the Distribution Info Grid    
//     self.getDistributionData();
    
    
        
    
  },
  methods: {
    ...mapActions("postModule",['DeleteItem']),
    onChange: function (e) {
        console.log("date range",e.sender._range);
        this.criteriaData.StartDate = e.sender._range.start?e.sender._range.start:'';
        this.criteriaData.EndDate = e.sender._range.end?e.sender._range.end:'';
    },
    getInputControls: function () {
        const self = this;
        // let response = self.getLocalInputControls(
        //     self.BaseModelInputControl.list
        // );           
        
        // self.dropdowns["Program"] = [];

        let resProgram = self.withFilter(
            self.BaseModelProgram.list,
            ""
        );

        let programData = [];
        if (resProgram.length) {
            resProgram.forEach(item => {
                let obj = {};
                obj.Id = item.Id;
                obj.Option = item.Title;
                programData.push(obj);
            });
        }
        self.criteriaData.Program = 
        self.dropdowns["Program"] = programData;
        console.log("Program details: ",self.dropdowns["Program"] );
    },

    onProgramChange: function(e) {
      const self = this;
      self.criteriaData.Program = e.dataItem.Id;
      //self.criteriaData.Partner.text = e.dataItem.Option;
    },


    getReportData: function (e) {
            e.preventDefault();
            let loader = this.$loading.show();
            let self = this; 
            self.displayGrid = false;
            self.DistributionReportData = [];
            self.currentGridConfig = JSON.parse(JSON.stringify(self.GridConfig));
            self.$nextTick(function () {
              // let multiSelect = $("#PartnerMultiSelect").data("kendoMultiSelect");
              let SelectedPartnerCount = self.criteriaData.Program.length;
              // alert(SelectedPartnerCount);

              if (self.criteriaData.Program !="" && self.criteriaData.StartDate !="" && self.criteriaData.StartDate !=null  && self.criteriaData.EndDate !="" && self.criteriaData.EndDate !=null) {
                  self.getDistributionReportData();

              } else {
                  self._AlertPopup("Please select Program, Start Date and End Date to proceed!", "warning");
              }
              loader.hide();
            });

    },

    getDistributionReportData: function(){  
        let self = this; 
        // self.displayGrid = true;
        self.DistributionReportData = [];
        // console.log("selected Program ", self.criteriaData.Program);
        let ProgramFilter = {filter: `ProgramId eq ${self.criteriaData.Program}`}
        let DistributionProgram = self.withFilter(BaseModelDistribution.list,ProgramFilter);  
        console.log("DistributionProgram ", DistributionProgram);  
        self.DistributionData = DistributionProgram.filter(obj=> new Date(obj.DistributionDate) >= new Date(self.criteriaData.StartDate) && new Date(obj.DistributionDate) <= new Date(self.criteriaData.EndDate))
        // let DistributionGroupbyData = _.groupBy(self.DistributionData,"PartnerId");
        
        // const getConfig1 = item => item.PartnerId;
        // const getConfig2 = item => item.DistributionType1;
        // const getConfig3 = item => item.DistributionType2;
        // const getConfig4 = item => item.DistributionPartnerType;

        // let DistributionGroupbyData = deepGroupBy(self.DistributionData, getConfig1, getConfig2, getConfig3,getConfig4);

        // Object.keys(DistributionGroupbyData).forEach(function(partnerkey, partnerindex) {
          
        //   //console.log(result[key])

        //   // key: the name of the object key
        //   // index: the ordinal position of the key within the object
        //   let result=DistributionGroupbyData[partnerkey];
        //   console.log("result", result);
        //   });
        
        // console.log("DistributionGroupbyData ", DistributionGroupbyData);  

        // self.DistributionData.forEach((element,index) => {
        //   element['Total'] = 0;
        //   let NewKey = 'Date' + moment(element.DistributionDate).format("MM_DD_YYYY") ;
        //   let NewColumnVal =   {
        //                 class: "value",
        //                 dataName: NewKey,
        //                 type: 'currency',
        //                 title: moment(element.DistributionDate).format("MM/DD/YYYY"),
        //                 template: '#=kendo.toString('+NewKey+', "c")#',
        //                 width: 150,
        //                 hidden: true,
        //                 readOnly: false
        //               }; 
        //   let PartnerComboIndex = self.DistributionReportData.findIndex(obj=> obj.PartnerId == element.PartnerId && obj.DistributionType1 == element.DistributionType1 && obj.DistributionType2 == element.DistributionType2 && obj.DistributionPartnerType == element.DistributionPartnerType );
        //   if(PartnerComboIndex >= 0){
        //     //Partner combo already exist. need to add the column based on the Distribution date           
        //     self.currentGridConfig.columns[NewKey] = NewColumnVal;
        //     self.DistributionReportData[PartnerComboIndex][NewKey] = element.DistributionAmount;
        //     self.DistributionReportData[PartnerComboIndex]['Total'] = self.DistributionReportData[PartnerComboIndex].Total + element.DistributionAmount;
        //   }else{
        //     //Partner combo not exist. need to add the column based on the Distribution date and need to add row
        //     self.currentGridConfig.columns[NewKey] = NewColumnVal; 
        //     element[NewKey] = element.DistributionAmount;
        //     element['Total'] = element.Total + element.DistributionAmount
        //     self.DistributionReportData.push(element);
        //   }
        // });

        // // self.DistributionReportData = self.DistributionData;
        // // console.log("DistributionReportData ", self.DistributionReportData);
        //  let TotalKey = 'Total' ;
        //  let TotalColumnVal =   {
        //                 class: "value",
        //                 dataName: 'Total',
        //                 type: 'currency',
        //                 title: 'Total',
        //                 template: '#=kendo.toString(Total, "c")#',
        //                 width: 150,
        //                 hidden: true,
        //                 readOnly: false
        //               }; 
        // self.currentGridConfig.columns[TotalKey] = TotalColumnVal;
        console.log("columns ",self.currentGridConfig.columns);
        console.log("DistributionReportData ", self.DistributionReportData);
        self.DistributionReportData = self.DistributionData;
        self.displayGrid = true;
        self.$nextTick(function () {
        self._loadGridSettings("DistributionReportGrid");
        });

    },

    
    toolbarOnClick: function (e) {
      e.preventDefault();
      switch (e.id) {
        // case "btnAddDistribution":
        //   this.AddDistribution();
        //   window.$("#BaseModal").modal("toggle");
        //   break;      
        // case "btnBulkImportDistribution":
        //   // this._AlertPopup("Bulk import screen is in progress...");   
        //   this.$router.push("/event/Distribution/Upload");       
        //   break;   
        case "btnRefresh":
          this.refreshGrid();
          break;
      }
      let ProgramFilter = {filter: "Id eq '"+this.criteriaData.Program+"'"}
      let ProgramName = this.withFilter(this.BaseModelProgram.list,ProgramFilter)[0];  
      var headerList=[{id:"Program Name", value:ProgramName.Title},
      {id:"Report Start Date", value:kendo.toString(this.criteriaData.StartDate, "MM/dd/yyyy")},
      {id:"Report End Date", value:kendo.toString(this.criteriaData.EndDate, "MM/dd/yyyy")},
      {id:"Report Generated On", value:kendo.toString(new Date, "MM/dd/yyyy")}]
      var arguementList={
        ...arguments,
        fileName:ProgramName.InvestmentTitle+"_"+kendo.toString(this.criteriaData.EndDate, "MM/dd/yyyy")+"_DistributionReport"+".xlsx",
        headers:headerList
      }
      this._baseToolBarEvents("DistributionReportGrid", arguementList);
    },
    refreshGrid: function(){  
      // console.log("refresh grid Distribution");   
      // this.getDistributionData();  
    },
   
  },
}
</script>
<style>
  #rangePicker{
    border: 0 !important;
  }
   #rangePicker .k-textbox{
    height: 40px;
    margin-top: 10px;
    background:#F0F0F0!important;
	  top: 2.5px!important;
  }
  #rangePicker .k-textbox-container{
    width: 49% !important;
  }
 
</style>
<style scoped>
.k-widget{
	font-size:1.12rem!important;
}
</style>
